import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ConstatsList from "@/pages/ConstatsList";
import Corbeille from "@/pages/Corbeille";
import RemisesList from "@/pages/RemisesList";
import RemiseDetail from "@/pages/RemiseDetail";
import ConstatCreate from "@/pages/ConstatCreate";
import ConstatImport from "@/pages/ConstatImport";
import Master from "@/pages/Master";
import ConstatDetail from "@/pages/ConstatDetail";
import Catalogue from "@/pages/admin/Catalogue";
import Typologies from "@/pages/admin/Typologies";
import UsersPage from "@/pages/admin/Users";
import Settings from "@/pages/admin/Settings";
import Dashboard from "@/pages/Dashboard";
import Register from "@/pages/Register";
import ConfirmEmail from "@/pages/ConfirmEmail";
import OfflineBanner from "@/components/OfflineBanner";

function App() {
  return (
    <div className="App">
      <BrandingProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/confirmer" element={<ConfirmEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Navigate to="/tableau-de-bord" replace />} />
              <Route path="/tableau-de-bord" element={<Dashboard />} />
              <Route path="/constats" element={<ConstatsList />} />
              <Route path="/corbeille" element={<Corbeille />} />
              <Route path="/cles" element={<RemisesList />} />
              <Route path="/cles/:id" element={<RemiseDetail />} />
              <Route path="/constats/nouveau" element={<ConstatCreate />} />
              <Route path="/constats/importer" element={<ConstatImport />} />
              <Route path="/constats/:id" element={<ConstatDetail />} />
            </Route>

            <Route element={<ProtectedRoute adminOnly />}>
              <Route path="/admin/catalogue" element={<Catalogue />} />
              <Route path="/admin/typologies" element={<Typologies />} />
              <Route path="/admin/utilisateurs" element={<UsersPage />} />
              <Route path="/admin/reglages" element={<Settings />} />
            </Route>

            <Route element={<ProtectedRoute superadminOnly />}>
              <Route path="/master" element={<Master />} />
            </Route>

            <Route path="*" element={<Navigate to="/constats" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <OfflineBanner />
      </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
